// @ts-expect-error esm import
import { cssToken } from '@cp/ui/utils';
export const name = 'VacancyCard';

export const Tokens = {
  textColor: cssToken(name, ['color', 'text']),
  repliedColor: cssToken(name, ['color', 'text', 'replied']),
  viewedColor: cssToken(name, ['color', 'text', 'viewed']),
};
